import logoUrl from "@/assets/logo-256.webp";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  alt?: string;
  priority?: boolean;
};

export function BrandLogo({ className, alt = "Seu Bolso Tranquilo", priority = false }: Props) {
  return (
    <img
      src={logoUrl}
      alt={alt}
      className={cn("object-contain select-none", className)}
      draggable={false}
      width={256}
      height={256}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      // @ts-expect-error fetchpriority is a valid HTML attribute not yet typed in React
      fetchpriority={priority ? "high" : "auto"}
    />
  );
}